/**
 * Asynchronously loads the component for Dashboard
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const Dashboard = lazyLoad(
    () => import('./index'),
    module => module.Dashboard,
    { fallback: <LoadingSpinner /> },
);
